var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('p', [_c('Loading')], 1) : [_c('Notification', {
    ref: "notification",
    staticClass: "s-mb-3",
    on: {
      "close": _vm.handleNotificationClosed
    }
  }), _c('div', {
    staticClass: "s-mb-4"
  }, [_c('img', {
    staticClass: "s-block s-w-full s-rounded-lg s-drop-shadow",
    attrs: {
      "src": _vm.membarCardImage
    }
  })]), _c('div', {
    staticClass: "s-rounded-lg s-bg-white s-card"
  }, [_c('div', {
    staticClass: "s-font-semibold s-flex"
  }, [_c('MemberIcon', {
    staticClass: "s-text-secondary s-mr-2"
  }), _c('span', {
    staticClass: "s-text-xl s-mr-3"
  }, [_vm._v(_vm._s(_vm.card.name))]), _c('span', [_vm._v(_vm._s(_vm.card.mobile_phone))])], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "s-block s-w-full s-mb-2",
    attrs: {
      "src": _vm.card.barcode_url
    }
  }), _c('span', {
    staticClass: "text-xs"
  }, [_vm._v("Card ID " + _vm._s(_vm.card.card_number))])]), _c('div', [_c('dl', {
    staticClass: "s-text-secondary"
  }, [_c('dt', {
    staticClass: "s-text-sm"
  }, [_vm._v("紅利點數")]), _c('dd', [_c('span', {
    staticClass: "s-font-bold s-text-xl"
  }, [_vm._v(_vm._s(_vm.card.point))]), _c('span', {
    staticClass: "s-font-semibold s-text-xs"
  }, [_vm._v("點")])])]), _c('dl', {
    staticClass: "s-text-gray-dark"
  }, [_c('dt', {
    staticClass: "s-text-sm"
  }, [_vm._v(_vm._s(_vm.thisYear) + "/12/31 到期點數")]), _c('dd', [_c('span', {
    staticClass: "s-font-bold s-text-xl"
  }, [_vm._v(_vm._s(_vm.card.this_expired_point))]), _c('span', {
    staticClass: "s-font-semibold s-text-xs"
  }, [_vm._v("點")])])])])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }